export default __webpack_public_path__ + "static/JONES-fdc561b8b7e86ddfdb7c4bbb96d035a9.svg";